import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import CountdownTimer from '../../../components/feature/CountdownTimer';

export default function CTA() {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  return (
    <section id="contato" className="py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-petrol-900 via-petrol-800 to-petrol-700 relative overflow-hidden" aria-labelledby="cta-heading">
      <div className="absolute inset-0 opacity-10" aria-hidden="true">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div
          ref={contentRef as React.RefObject<HTMLDivElement>}
          className={`text-center transition-all duration-700 ease-out ${contentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-strategic-green-500 to-strategic-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 sm:mb-8 shadow-2xl" aria-hidden="true">
            <i className="ri-shield-check-line text-3xl sm:text-4xl text-white"></i>
          </div>

          <h2 id="cta-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Transforme Sua Gestão de Seguros{' '}
            <span className="text-strategic-green-400">Hoje</span>
          </h2>

          <p className="text-base sm:text-lg lg:text-xl text-gray-100 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-4">
            Solicite uma análise gratuita e descubra como <strong className="text-white">economizar até 35%</strong> com gestão profissional de riscos e seguros.
          </p>

          <div className="mb-8 sm:mb-10">
            <CountdownTimer location="cta-principal" />
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contato"
              className="group relative px-8 py-4 bg-strategic-green-500 text-white font-semibold rounded-lg overflow-hidden transition-all duration-300 hover:bg-strategic-green-600 hover:scale-105 hover:shadow-2xl whitespace-nowrap"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                Solicitar Análise Gratuita
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
            <a
              href="/servicos"
              className="group relative px-8 py-4 bg-action-orange-500 text-white font-semibold rounded-lg overflow-hidden transition-all duration-300 hover:bg-action-orange-600 hover:scale-105 hover:shadow-2xl whitespace-nowrap"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                Conhecer Serviços
                <i className="ri-service-line text-xl group-hover:rotate-12 transition-transform"></i>
              </span>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-gray-200 text-xs sm:text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-fill text-strategic-green-400 text-base" aria-hidden="true"></i>
              <span>Análise 100% Gratuita</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-strategic-green-400 text-base" aria-hidden="true"></i>
              <span>Resposta em 24h</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-lock-line text-strategic-green-400 text-base" aria-hidden="true"></i>
              <span>Sem Compromisso</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
